import React from 'react'
import { makeStyles } from '@material-ui/core/styles';


import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';


import './css/landing-page.css';

import Button from '../../components/button/button';
import Bullet from './bullet';
import DropdownContent from '../../components/dropdown-content/dropdown-content';

import Testimonial from '../../components/testimonial/testimonial'


const useStyles = makeStyles((theme) => ({
    root: {
      position: 'relative',
    }
  }));
  


function LandingPage(props) {

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [showMenus, setShowMenus] = React.useState(false);

    // const menuElement = document.querySelector(".menu-block")

    // document.addEventListener("mousedown", (event) => {
    //   try{
    //     if (menuElement?.contains(event.target)) {
    //         console.log("Clicked Inside");
    //       } else {
    //         setShowMenus(false)
    //         console.log("Clicked Outside / Elsewhere");
    //       }
    //   }catch(error){
    //     setShowMenus(false)
    //     console.log("not in dom")
    //   }
    // });

    const handleClick = () => {
        setOpen((prev) => !prev);
      };
    
      const handleClickAway = () => {
        setOpen(false);
      };

    return (
        <>
            {/*
            <div className="box-management box-bg">
            */}
            <div className="box-management box-bg">
                <div style={{ height: 54 }} className="shrink-height"/>

                <div className="container">
                    <nav className="navBar">

                        <div 
                            className="d-block d-md-none d-lg-none"
                        >
                            <span 
                                onClick={() => {
                                            setShowMenus(prev => !prev)
                                        }
                                    } 
                                style={{cursor: "pointer", display: 'flex', alignItems: 'center'}}
                            >
                                    <div className="logo-area-login">
                                        <img src={require("../../components/asset/airvendlogo 1.svg").default} alt="" className="login-logo" />
                                    </div>
                                <ExpandMoreIcon />
                            </span>
                        </div>



                        <div className={showMenus ? "menu-block" : "menu-hidden"}>
                            <ul className="left-nav">




                                <li>
                                    <a className="d-none d-md-block d-lg-block" href="/">
                                        <div className="logo-area-login">
                                            <img src={require("../../components/asset/airvendlogo 1.svg").default} alt="" className="login-logo" />
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://app.airvend.ng/login">
                                        Personal
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        Merchant
                                    </a>
                                </li>
                                <li>
                                    <a href="https://documenter.getpostman.com/view/6349852/SVSHrpfv">
                                        Developer
                                    </a>
                                </li>
                                <li id="noHover" style={{position: "relative"}}>
                                    
                                    <ClickAwayListener onClickAway={handleClickAway}>
                                        <div style={{position: "relative"}}>
                                            <span onClick={handleClick} style={{cursor: "pointer", display: 'flex', alignItems: 'center'}}>
                                                Learn <ExpandMoreIcon />
                                            </span>
                                            {open ? (
                                            <div className="dropdown">
                                                <DropdownContent 
                                                    icon={
                                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z" fill="#F5E6FE"/>
                                                            <path d="M14.6011 8.11652L8.19 7.14264C7.8925 7.09627 7.58888 7.17764 7.36138 7.37014C7.13388 7.56877 7 7.85402 7 8.15152V20.4426C7 20.7638 7.2625 21.0263 7.58362 21.0263H9.47975V17.9638C9.47975 17.3976 9.93475 16.9426 10.5009 16.9426H11.9595C12.5256 16.9426 12.9806 17.3976 12.9806 17.9638V21.0263H15.4595V9.12627C15.4586 8.62402 15.0964 8.19877 14.6011 8.11652ZM10.2086 15.6301H9.33362C9.09212 15.6301 8.89612 15.4341 8.89612 15.1926C8.89612 14.9511 9.09212 14.7551 9.33362 14.7551H10.2086C10.4501 14.7551 10.6461 14.9511 10.6461 15.1926C10.6461 15.4341 10.4501 15.6301 10.2086 15.6301ZM10.2086 13.8801H9.33362C9.09212 13.8801 8.89612 13.6841 8.89612 13.4426C8.89612 13.2011 9.09212 13.0051 9.33362 13.0051H10.2086C10.4501 13.0051 10.6461 13.2011 10.6461 13.4426C10.6461 13.6841 10.4501 13.8801 10.2086 13.8801ZM10.2086 12.1301H9.33362C9.09212 12.1301 8.89612 11.9341 8.89612 11.6926C8.89612 11.4511 9.09212 11.2551 9.33362 11.2551H10.2086C10.4501 11.2551 10.6461 11.4511 10.6461 11.6926C10.6461 11.9341 10.4501 12.1301 10.2086 12.1301ZM10.2086 10.3801H9.33362C9.09212 10.3801 8.89612 10.1841 8.89612 9.94264C8.89612 9.70114 9.09212 9.50514 9.33362 9.50514H10.2086C10.4501 9.50514 10.6461 9.70114 10.6461 9.94264C10.6461 10.1841 10.4501 10.3801 10.2086 10.3801ZM13.125 15.6301H12.25C12.0085 15.6301 11.8125 15.4341 11.8125 15.1926C11.8125 14.9511 12.0085 14.7551 12.25 14.7551H13.125C13.3665 14.7551 13.5625 14.9511 13.5625 15.1926C13.5625 15.4341 13.3665 15.6301 13.125 15.6301ZM13.125 13.8801H12.25C12.0085 13.8801 11.8125 13.6841 11.8125 13.4426C11.8125 13.2011 12.0085 13.0051 12.25 13.0051H13.125C13.3665 13.0051 13.5625 13.2011 13.5625 13.4426C13.5625 13.6841 13.3665 13.8801 13.125 13.8801ZM13.125 12.1301H12.25C12.0085 12.1301 11.8125 11.9341 11.8125 11.6926C11.8125 11.4511 12.0085 11.2551 12.25 11.2551H13.125C13.3665 11.2551 13.5625 11.4511 13.5625 11.6926C13.5625 11.9341 13.3665 12.1301 13.125 12.1301ZM13.125 10.3801H12.25C12.0085 10.3801 11.8125 10.1841 11.8125 9.94264C11.8125 9.70114 12.0085 9.50514 12.25 9.50514H13.125C13.3665 9.50514 13.5625 9.70114 13.5625 9.94264C13.5625 10.1841 13.3665 10.3801 13.125 10.3801Z" fill="#BE63F9"/>
                                                            <path d="M20.195 13.3507L16.0414 12.481V21.0262H19.9789C20.5415 21.0262 21 20.5686 21 20.0051V14.3482C21 13.8661 20.671 13.4557 20.195 13.3507ZM18.8125 19.2762H17.9375C17.696 19.2762 17.5 19.0802 17.5 18.8387C17.5 18.5972 17.696 18.4012 17.9375 18.4012H18.8125C19.054 18.4012 19.25 18.5972 19.25 18.8387C19.25 19.0802 19.054 19.2762 18.8125 19.2762ZM18.8125 17.5262H17.9375C17.696 17.5262 17.5 17.3302 17.5 17.0887C17.5 16.8472 17.696 16.6512 17.9375 16.6512H18.8125C19.054 16.6512 19.25 16.8472 19.25 17.0887C19.25 17.3302 19.054 17.5262 18.8125 17.5262ZM18.8125 15.7762H17.9375C17.696 15.7762 17.5 15.5802 17.5 15.3387C17.5 15.0972 17.696 14.9012 17.9375 14.9012H18.8125C19.054 14.9012 19.25 15.0972 19.25 15.3387C19.25 15.5802 19.054 15.7762 18.8125 15.7762Z" fill="#D9A4FC"/>
                                                        </svg>
                                                    }
                                                    heading="About" 
                                                    body="Learn more about our company Callphone Limited."
                                                    onClick={() => console.log("About")}
                                                />
                                                <DropdownContent 
                                                    icon={
                                                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect width="28" height="28" rx="5.25" fill="#0F9AF0" fill-opacity="0.1"/>
                                                                <path d="M14 18.25L13.0625 20.125L14 22C15.0355 22 15.875 21.1605 15.875 20.125C15.875 19.0895 15.0355 18.25 14 18.25Z" fill="#0A77E8"/>
                                                                <path d="M12.125 20.125C12.125 21.1605 12.9645 22 14 22V18.25C12.9645 18.25 12.125 19.0895 12.125 20.125Z" fill="#0F9AF0"/>
                                                                <path d="M14 6L12.125 7.875L14 9.75C14.6203 9.75 15.125 10.2547 15.125 10.875C15.125 11.2056 14.9799 11.5184 14.7269 11.7335L14 12.3514L12.75 14.832L14 17.3125H15.875V15.6794L17.1555 14.5908C18.2483 13.6622 18.875 12.3079 18.875 10.875C18.875 8.18691 16.6881 6 14 6V6Z" fill="#0A77E8"/>
                                                                <path d="M12.125 13.9456V17.3125H14V12.3514L12.125 13.9456Z" fill="#0F9AF0"/>
                                                                <path d="M9.125 10.875V11.3438H12.875V10.875C12.875 10.2547 13.3797 9.75 14 9.75V6C11.3119 6 9.125 8.18691 9.125 10.875Z" fill="#0F9AF0"/>
                                                            </svg>
                                                    }
                                                    heading="FAQs" 
                                                    body="Frequently asked questions from other users." 
                                                    onClick={() => {
                                                        window.location.href = "#faqs"
                                                    }}
                                                />
                                                <DropdownContent 
                                                    icon={
                                                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect width="28" height="28" rx="5.25" fill="#FF5CF0" fill-opacity="0.1"/>
                                                                <path d="M19.1805 19.5421L18.7634 19.9593L16.7094 17.9053C16.1996 17.3954 15.8521 16.746 15.7108 16.039L15.3789 14.3789L17.039 14.7107C17.095 14.7219 17.1505 14.7349 17.2057 14.7486L17.6443 17.1383C17.7856 17.8454 18.1331 18.4947 18.643 19.0046L19.1805 19.5421ZM9.34375 17.4844V9.51562C9.34375 7.89759 10.6554 6.58594 12.2734 6.58594L18.4829 6.56312L18.4844 6.55664L10.5156 6.58594C8.89759 6.58594 7.58594 7.89759 7.58594 9.51562V17.4844C7.58594 19.1024 8.89759 20.4141 10.5156 20.4141L12.0408 20.4049C10.5315 20.2863 9.34375 19.0241 9.34375 17.4844Z" fill="#CEE1F2"/>
                                                                <path d="M16.082 21H10.5156C8.57711 21 7 19.4229 7 17.4844V9.51562C7 7.57711 8.57711 6 10.5156 6H18.4844C20.4229 6 22 7.57711 22 9.51562V15.126C22 15.4496 21.7377 15.7119 21.4141 15.7119C21.0904 15.7119 20.8281 15.4496 20.8281 15.126V9.51562C20.8281 8.22328 19.7767 7.17188 18.4844 7.17188H10.5156C9.22328 7.17188 8.17188 8.22328 8.17188 9.51562V17.4844C8.17188 18.7767 9.22328 19.8281 10.5156 19.8281H16.082C16.4056 19.8281 16.668 20.0904 16.668 20.4141C16.668 20.7377 16.4056 21 16.082 21ZM21.3736 20.3736C22.2075 19.5397 22.2075 18.1829 21.3736 17.3491L19.3196 15.2951C18.726 14.7014 17.977 14.3007 17.1538 14.1362L15.4938 13.8043C15.3017 13.7659 15.1031 13.8261 14.9646 13.9646C14.8261 14.1031 14.766 14.3017 14.8043 14.4938L15.1362 16.1539C15.3007 16.9771 15.7015 17.726 16.2951 18.3197L18.3491 20.3736C18.753 20.7775 19.2901 21 19.8613 21C20.4326 21 20.9697 20.7775 21.3736 20.3736ZM16.9241 15.2853C17.5197 15.4043 18.0615 15.6942 18.491 16.1237L20.5449 18.1777C20.9219 18.5546 20.9219 19.168 20.5449 19.5449C20.3624 19.7275 20.1196 19.8281 19.8613 19.8281C19.6031 19.8281 19.3603 19.7275 19.1777 19.5449L17.1237 17.491C16.6943 17.0615 16.4044 16.5197 16.2853 15.9242L16.1257 15.1257L16.9241 15.2853Z" fill="#1428BF"/>
                                                                <path d="M18.4844 10.2773H13.123C12.7994 10.2773 12.5371 10.015 12.5371 9.69141C12.5371 9.36779 12.7994 9.10547 13.123 9.10547H18.4844C18.808 9.10547 19.0703 9.36779 19.0703 9.69141C19.0703 10.015 18.808 10.2773 18.4844 10.2773ZM19.0703 12.0352C19.0703 11.7115 18.808 11.4492 18.4844 11.4492H10.5156C10.192 11.4492 9.92969 11.7115 9.92969 12.0352C9.92969 12.3588 10.192 12.6211 10.5156 12.6211H18.4844C18.808 12.6211 19.0703 12.3588 19.0703 12.0352ZM13.2109 14.3789C13.2109 14.0553 12.9486 13.793 12.625 13.793H10.5156C10.192 13.793 9.92969 14.0553 9.92969 14.3789C9.92969 14.7025 10.192 14.9648 10.5156 14.9648H12.625C12.9486 14.9648 13.2109 14.7025 13.2109 14.3789ZM9.92969 9.63281C9.92969 10.0373 10.2576 10.3652 10.6621 10.3652C11.0666 10.3652 11.3945 10.0373 11.3945 9.63281C11.3945 9.22831 11.0666 8.90039 10.6621 8.90039C10.2576 8.90039 9.92969 9.22831 9.92969 9.63281Z" fill="#FF5CF0"/>
                                                            </svg>
                                                    }
                                                    heading="Blog" 
                                                    body="Conversations about Airvend and some scenes behind." 
                                                    onClick={() => console.log("Blog")}
                                                />
                                            </div>
                                            ) : null}
                                        </div>
                                    </ClickAwayListener>
                                </li>
                            </ul>
                        </div>


                        <div>
                            <ul className="right-nav">
                                <li>
                                    <a href="https://app.airvend.ng/login">
                                        Login
                                    </a>
                                </li>
                                <li>
                                    <div>
                                        <Button
                                            btn_name="Create Account"
                                            color="btn-white"
                                            onClick={() => {
                                                window.location.href = "https://app/airvend.ng/register"
                                            }}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </nav>
                </div>
                <div style={{ height: 136 }} />

                <div className="container" style={{backgroundColor: ""}}>
                    <div className="welcome-message">
                        <div className="first-text">
                            <div style={{fontWeight: "400px"}}>
                                Payments
                            </div>
                            made easy!
                        </div>

                        <div className="second-text">
                            Airvend is a bills payment platform that makes it easier for users to make payment to their biller & accept payments from their customers.
                        </div>

                        <div className="app-icons">
                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="https://airvend.ng/"}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.05 2.927C13.148 -0.974999 6.83 -0.975999 2.927 2.927C-0.975003 6.83 -0.976003 13.147 2.927 17.05C6.83 20.953 13.147 20.953 17.05 17.05C20.953 13.147 20.953 6.83 17.05 2.927ZM16.633 15.627C16.166 15.209 15.667 14.84 15.141 14.522C15.489 13.321 15.695 11.999 15.743 10.625H18.679C18.547 12.477 17.835 14.215 16.633 15.627ZM1.298 10.625H4.234C4.283 11.999 4.489 13.321 4.836 14.522C4.31 14.84 3.811 15.209 3.345 15.627C2.142 14.214 1.431 12.477 1.298 10.625ZM3.345 4.351C3.811 4.768 4.31 5.137 4.836 5.455C4.489 6.657 4.283 7.978 4.234 9.352H1.298C1.431 7.5 2.142 5.763 3.345 4.351ZM9.352 5.587C8.314 5.513 7.314 5.257 6.386 4.835C6.926 3.445 7.92 1.779 9.352 1.366V5.586V5.587ZM9.352 6.862V9.352H5.507C5.551 8.19 5.716 7.074 5.99 6.052C7.044 6.514 8.178 6.789 9.352 6.862ZM9.352 10.625V13.115C8.178 13.188 7.044 13.464 5.99 13.925C5.716 12.903 5.551 11.787 5.507 10.625H9.352ZM9.352 14.39V18.61C7.92 18.198 6.926 16.532 6.386 15.142C7.314 14.72 8.314 14.465 9.352 14.39ZM10.625 14.39C11.663 14.465 12.664 14.72 13.591 15.142C13.051 16.532 12.057 18.198 10.625 18.611V14.391V14.39ZM10.625 13.115V10.625H14.47C14.426 11.787 14.261 12.903 13.987 13.925C12.933 13.464 11.799 13.188 10.625 13.115ZM10.625 9.352V6.862C11.799 6.789 12.933 6.514 13.987 6.052C14.261 7.074 14.426 8.19 14.47 9.352H10.625ZM10.625 5.587V1.367C12.057 1.779 13.052 3.446 13.591 4.835C12.664 5.257 11.663 5.513 10.625 5.587ZM13.484 2.002C14.298 2.359 15.058 2.842 15.739 3.442C15.415 3.728 15.073 3.988 14.716 4.219C14.398 3.434 13.993 2.67 13.484 2.002ZM5.262 4.219C4.904 3.988 4.562 3.729 4.238 3.442C4.919 2.842 5.679 2.359 6.494 2.002C5.984 2.67 5.579 3.434 5.262 4.219ZM5.262 15.758C5.579 16.543 5.984 17.307 6.494 17.975C5.679 17.619 4.919 17.135 4.238 16.535C4.562 16.249 4.904 15.99 5.262 15.758ZM14.716 15.758C15.073 15.99 15.416 16.248 15.739 16.535C15.059 17.135 14.299 17.619 13.484 17.975C13.993 17.307 14.398 16.543 14.716 15.758ZM15.743 9.352C15.695 7.978 15.489 6.657 15.141 5.455C15.667 5.137 16.166 4.768 16.633 4.351C17.835 5.763 18.547 7.501 18.679 9.352H15.743Z" fill="white"/>
                                </svg>
                            </div>

                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="http://bit.ly/3Airpay"}
                            >
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.44 7.066L15.738 7.514L15.308 7.838C14.695 8.301 13.575 9.145 13.575 10.818C13.575 12.798 14.843 13.56 15.453 13.926C15.722 14.088 16 14.255 16 14.62C16 14.858 14.098 19.97 11.336 19.97C10.66 19.97 10.182 19.767 9.761 19.588C9.335 19.408 8.967 19.251 8.359 19.251C8.051 19.251 7.661 19.397 7.249 19.551C6.685 19.761 6.048 20 5.324 20H5.304C2.402 19.983 0 14.062 0 11.046C0 6.12 3.698 5.042 5.124 5.042C5.766 5.042 6.452 5.294 7.057 5.517C7.48 5.672 7.917 5.833 8.161 5.833C8.307 5.833 8.65 5.696 8.953 5.577C9.599 5.319 10.403 5 11.34 5C12.045 5 14.165 5.153 15.44 7.066ZM10.998 0C11.058 2.421 9.54 4.1 8.024 3.995C7.774 2.063 9.539 0 10.998 0Z" fill="white"/>
                                </svg>
                            </div>

                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="https://bit.ly/3Airvend"}
                            >
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.645 11L14 13.445L3 20L11.645 11ZM0.857 0L11 9.998L0.857 20C0.344 19.734 0 19.25 0 18.62V1.38C0 0.75 0.344 0.265 0.857 0ZM15.361 7L17.477 8.321C18.167 8.875 18.167 10.123 17.52 10.677L15.361 12L13 9.5L15.361 7ZM3 0L14 6.555L11.645 9L3 0Z" fill="white"/>
                                </svg>
                            </div>

                        </div>



                    </div>
                    

                </div>


            </div>

            <div className="" style={{backgroundColor: ""}}>
                <div className="d-none d-sm-block d-md-block d-lg-none" style={{width: "100%", height: 40, backgroundColor: ""}}></div>


                {/* <div className="new-away-transact"> */}
                <div className="row new-away-transact" style={{backgroundColor: ""}}>
                    <div className="col-lg-6 d-none d-sm-none d-md-none d-lg-block">
                        <img className="img-fluid" src={require("../../components/asset/landing-phone.svg").default} alt="Phone in planet" />
                    </div>

                    {/* <div className="text-section"> */}
                    <div className="col-lg-6">
                        <div style={{padding: 20, display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                            <div className="heading">
                                A new way to transact
                            </div>
                            <br />

                            <Bullet heading="Subscriptions" body="Recharge Card top-ups and other payments are done as easy as you can imagine on the Airvend app." />
                            <br />
                            <Bullet heading="Bill Payments" body="There are a few easier and faster things than making bill payments through the Airvend app." />
                            <br />
                            <Bullet heading="Fund Transfers" body="A simple and seamless way to send money between bank accounts. Using the  Wallet-to-Wallet feature, you can transfer to Airvend users directly." />

                        </div>
                    </div>
                </div>
                
                <div className="d-none d-md-block d-lg-none" style={{width: "100%", height: 40, backgroundColor: ""}}></div>

                <div className="row new-away-transact_r">

                    {/* <div className="text-section"  style={{width: "50%", display: "flex", justifyContent: "center", alignItems: "center"}}> */}
                    <div className="col-lg-6 text-section" style={{backgroundColor: ""}} >
                        <div style={{padding: 20}}>
                            <div>
                                <div className="heading">
                                    Earn money as a Merchant
                                </div>
                            </div>
                            <br />
                                <div className="write-up">
                                        With Airvend’s Airpay POS you can make money by becoming a mobile money agent delivering seamless banking services to your customers. The airpay POS enables you to provide services  -
                                </div>
                            <br />
                            <div>
                                <div className="xtra-bullet">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 0C12.4992 0 12.904 0.4048 12.904 0.904C12.904 1.404 12.4992 1.8088 12 1.8088C6.3808 1.8088 1.8088 6.3808 1.8088 12C1.8088 17.6192 6.3808 22.1912 12 22.1912C17.6192 22.1912 22.1912 17.6192 22.1912 12C22.1912 11.5 22.596 11.096 23.0952 11.096C23.5952 11.096 24 11.5008 24 12C24 18.616 18.616 24 12 24C5.3832 24 0 18.616 0 12C0 5.3832 5.3832 0 12 0ZM22.0344 3.28C22.388 2.9264 22.9608 2.928 23.3144 3.2808C23.6664 3.6344 23.6664 4.2072 23.312 4.5608L11.7944 16.048C11.6248 16.216 11.3944 16.312 11.156 16.312L11.1368 16.3112C10.8904 16.3064 10.6568 16.2008 10.4904 16.02L5.9376 11.076C5.5992 10.708 5.6224 10.1352 5.9904 9.7968C6.3584 9.4592 6.9304 9.4824 7.2688 9.8496L11.1832 14.1024L22.0344 3.28Z" fill="#6AB04C"/>
                                    </svg>
                                    <span className="spantext">Cash Deposit / Transfer / Withdrawals</span>
                                </div>
                                <div className="xtra-bullet">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 0C12.4992 0 12.904 0.4048 12.904 0.904C12.904 1.404 12.4992 1.8088 12 1.8088C6.3808 1.8088 1.8088 6.3808 1.8088 12C1.8088 17.6192 6.3808 22.1912 12 22.1912C17.6192 22.1912 22.1912 17.6192 22.1912 12C22.1912 11.5 22.596 11.096 23.0952 11.096C23.5952 11.096 24 11.5008 24 12C24 18.616 18.616 24 12 24C5.3832 24 0 18.616 0 12C0 5.3832 5.3832 0 12 0ZM22.0344 3.28C22.388 2.9264 22.9608 2.928 23.3144 3.2808C23.6664 3.6344 23.6664 4.2072 23.312 4.5608L11.7944 16.048C11.6248 16.216 11.3944 16.312 11.156 16.312L11.1368 16.3112C10.8904 16.3064 10.6568 16.2008 10.4904 16.02L5.9376 11.076C5.5992 10.708 5.6224 10.1352 5.9904 9.7968C6.3584 9.4592 6.9304 9.4824 7.2688 9.8496L11.1832 14.1024L22.0344 3.28Z" fill="#6AB04C"/>
                                    </svg>
                                    <span className="spantext">CableTV and Electricity Bill Payments</span>
                                </div>
    
                                <div className="xtra-bullet">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 0C12.4992 0 12.904 0.4048 12.904 0.904C12.904 1.404 12.4992 1.8088 12 1.8088C6.3808 1.8088 1.8088 6.3808 1.8088 12C1.8088 17.6192 6.3808 22.1912 12 22.1912C17.6192 22.1912 22.1912 17.6192 22.1912 12C22.1912 11.5 22.596 11.096 23.0952 11.096C23.5952 11.096 24 11.5008 24 12C24 18.616 18.616 24 12 24C5.3832 24 0 18.616 0 12C0 5.3832 5.3832 0 12 0ZM22.0344 3.28C22.388 2.9264 22.9608 2.928 23.3144 3.2808C23.6664 3.6344 23.6664 4.2072 23.312 4.5608L11.7944 16.048C11.6248 16.216 11.3944 16.312 11.156 16.312L11.1368 16.3112C10.8904 16.3064 10.6568 16.2008 10.4904 16.02L5.9376 11.076C5.5992 10.708 5.6224 10.1352 5.9904 9.7968C6.3584 9.4592 6.9304 9.4824 7.2688 9.8496L11.1832 14.1024L22.0344 3.28Z" fill="#6AB04C"/>
                                    </svg>
                                    <span className="spantext">Airtime and Internet Data Vending</span>
                                </div>
    
    

                                <div className="xtra-bullet">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 0C12.4992 0 12.904 0.4048 12.904 0.904C12.904 1.404 12.4992 1.8088 12 1.8088C6.3808 1.8088 1.8088 6.3808 1.8088 12C1.8088 17.6192 6.3808 22.1912 12 22.1912C17.6192 22.1912 22.1912 17.6192 22.1912 12C22.1912 11.5 22.596 11.096 23.0952 11.096C23.5952 11.096 24 11.5008 24 12C24 18.616 18.616 24 12 24C5.3832 24 0 18.616 0 12C0 5.3832 5.3832 0 12 0ZM22.0344 3.28C22.388 2.9264 22.9608 2.928 23.3144 3.2808C23.6664 3.6344 23.6664 4.2072 23.312 4.5608L11.7944 16.048C11.6248 16.216 11.3944 16.312 11.156 16.312L11.1368 16.3112C10.8904 16.3064 10.6568 16.2008 10.4904 16.02L5.9376 11.076C5.5992 10.708 5.6224 10.1352 5.9904 9.7968C6.3584 9.4592 6.9304 9.4824 7.2688 9.8496L11.1832 14.1024L22.0344 3.28Z" fill="#6AB04C"/>
                                    </svg>
                                    <span className="spantext">Universal Recharge Voucher Printing</span>
                                </div>
    
                            </div>
                            


                        </div>
                    </div>

                    <div className="d-none d-md-none d-lg-block col-lg-6 right_image" style={{}}>
                        <img className="img-fluid" style={{marginLeft: 0}} src={require("../../components/asset/landing-atm.svg").default} alt="Phone in planet" />
                    </div>

                </div>


                <div className="row payment-product" style={{backgroundColor: ""}}>

                    <div className="d-none d-md-none d-lg-block col-lg-6">
                        <img className="img-fluid" src={require("../../components/asset/landing-layer.svg").default} alt="Phone in planet" />
                    </div>

                    <div className="col-lg-6 payment-des-column">
                        <div className="heading">
                            Build payment products
                        </div>

                        <div className="details">
                            Build custom service dashboards  with  our well-documented APIs

                            Developers certainly appreciate our thorough and well-documented APIs that let you sell anything from airtime, Electricity Dstv and other value added services including our unique universal recharge vouchers. If you desire it,  then we can help you build it.

                        </div>

                        <div style={{width: "200px"}}>
                            <Button
                                btn_name="API Documentation"
                                color="btn-white py-8"
                                onClick={() => {
                                    window.location.href = "https://documenter.getpostman.com/view/6349852/SVSHrpfv"
                                }}
                            />
                        </div>   

                    </div>

                </div>


                <div className="row the-promise" style={{backgroundColor: ""}}>

                    <div className="col-lg-6 promise-text">
                        <div className="promise-heading">
                            We’re with You all the way!
                        </div>
                        <br />
                        <div className="promise-body">
                            We understand that delivering great support is just as important as building a great product so our customer support team is always on the other end of our various channels so you’d never have to worry about swiftly
                            resolving any issues you might have.
                        </div>
                        <br />

                        <div style={{display: "flex"}}>
                            <div className="promise-tile">
                            </div>
                            <div className="promise-tile">
                            </div>
                            <div className="promise-tile">
                            </div>
                        </div>

                    </div>

                    <div className="d-none d-md-none d-lg-block col-lg-6">
                        <img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />
                    </div>


                </div>

                <div className="">
                    
                    {/*
                    <div className="testimonial col-lg-12">
                    */}
                    <div className="testimonial">
                      {/*  <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />
                        <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />
                        <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />
                        <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />
                        <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />
                        <Testimonial 
                            name="Kene Ohiaeri"
                            location="Abuja"
                            image={<img src={require("../../components/asset/landing-promise.png").default} alt="Phone in planet" />}
                            body="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint." 
                        />*/}
                    </div>


                </div>


                
                <div id="faqs" className="accordion">

                    <div className="accordion-head">
                        Frequently Asked Questions
                    </div>

                    <div style={{height: "70px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">HOW TO REGISTER?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                        For Airvend Web
                                </Typography>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Scroll down to Create Account
                                       </li>
                                        <li>
                                            Input your phone number into the Enter Phone Number section
                                        </li>
                                        <li>
                                            Click on Get free account
                                        </li>
                                        <li>
                                            Fill in the subsequent required information and submit
                                        </li>
                                        <li>
                                            You are good to go.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                        Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>
                                <Typography className="accordion-body">
                                        For Airvend App
                                </Typography>

                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Scroll down to Create Account
                                       </li>
                                        <li>
                                            Input your phone number into the Enter Phone Number section
                                       </li>
                                            Click on Get free account
                                        <li>
                                            Fill in the subsequent required information and submit
                                        </li>
                                        <li>
                                            You are good to go.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>



                                <Typography className="accordion-body">
                                    For Airvend iOS
                                </Typography>

                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Scroll down to Create Account
                                       </li>
                                        <li>
                                            Input your phone number into the Enter Phone Number section
                                       </li>
                                            Click on Get free account
                                        <li>
                                            Fill in the subsequent required information and submit
                                        </li>
                                        <li>
                                            You are good to go.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>


                            </div>
                        </AccordionDetails>
                    </Accordion>


                    <div style={{height: "24px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How to Fund an Airvend Wallet</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                        You can only fund your Airvend Wallet with your bank’s debit card; this process is powered by Flutterwave and guarantees the safety and security of your cards.
                                </Typography>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            We accept all MasterCard, Visa and Verve cards, foreign cards like the American Express and Discover cards are also accepted.
                                       </li>
                                        <li>
                                            Typically, it takes a little less than 3minutes for funds to reflect on your wallet and any funding issue is solved within 24hrs of a business day.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    To  fund your wallet: 
                                </Typography>

                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Sign Up or Login to the Airvend app 
                                       </li>
                                        <li>
                                            Tap on the add funds icon on the app’s dashboard
                                       </li>
                                            Enter the Deposit amount you want to fund with. There’s a minimum of 200 Naira and $5 for international cards
                                        <li>
                                            Tap on pay with new card and follow the on-screen instructions.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Once the process is complete, deposited funds would reflect on your airvend Wallet.
                                </Typography>



                                <Typography className="accordion-body">
                                    Was this  helpful? Have more questions? You can email us: support@airvend.ng.
                                </Typography>




                            </div>
                        </AccordionDetails>
                    </Accordion>


                    <div style={{height: "24px"}}></div>




                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">What services do you offer?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            Having created an airvend account and funded your Airvend wallet, you can ultimately begin to;
                        </Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Send money to another Airvend account, any other e-wallet and any bank
                                        </li>
                                        <li>
                                            Receive money from another Airvend account, any other e-wallet and any bank
                                        </li>
                                        <li>
                                            Save money
                                        </li>
                                        <li>
                                            Directly pay for Electricity bills
                                        </li>
                                        <li>
                                            Directly pay for TV decoder subscriptions
                                        </li>
                                        <li>
                                             Directly purchase data and Airtime from network  providers in Nigeria
                                        </li>
                                        <li>
                                            Make payments for JAMB and WAEC
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How to pay for Electricity on Airvend?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            You can purchase Power on the Airvend App in 3 easy steps
                        </Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Sign Up or Login to the Airvend App
                                        </li>
                                        <li>
                                            On the app’s  dashboard tap on the power icon
                                        </li>
                                        <li>
                                            Select the Distribution company you intend to pay for (e.g IKEDC)
                                        </li>
                                        <li>
                                            Select account type and Input meter number
                                        </li>
                                        <li>
                                            Proceed to payment( You can either pay from your Airvend Wallet or with Saved card)
                                        </li>
                                        <li>
                                            Voila! Recharge pin is sent.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng.
                                </Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>




                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How to pay for DSTV or GoTV on Airvend?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            You can pay for Cable TV on the Airvend App in 3 easy steps
                        </Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Sign Up or Login to the Airvend App
                                        </li>
                                        <li>
                                            On the app’s dashboard tap on the  Cable TV icon.
                                        </li>
                                        <li>
                                            Select service provider( DSTV, OR GOTV)
                                        </li>
                                        <li>
                                            Select Bouquet  and Input decoder number
                                        </li>
                                        <li>
                                            Proceed to payment( You can either pay from your Airvend Wallet or with Saved card)
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    Seamless right?
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng.
                                </Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How to use an Airvend Virtual Dollar Card</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                             The Airvend Virtual Dollar Card is a non-physical card for making payments online in dollars.
                            You can create your virtual card on any of the airvend platforms; either on the Mobile App or Web App.
                            <br />
                        </Typography>

                        <Typography className="accordion-body">
                            To do this your airvend wallet should be funded with at least the naira equivalent of $10 so your virtual card is funded with dollars converted from the naira in your Airvend wallet at the current dollar rate.
                        </Typography>

                        <Typography className="accordion-body">
                            You can also convert back the money in your dollar card to naira by transferring it to your Airvend Wallet.
                        </Typography>

                        <Typography className="accordion-body">
                            To get the Card:
                        </Typography>


                        </AccordionDetails>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                             Login or sign up on the Airvend platform
                                        </li>
                                        <li>
                                            Click on Dollar cards
                                        </li>
                                        <li>
                                            Complete the funding process.
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                    The virtual dollar card comes with regular card details (your card name, card number, expiry date and the three-digit CVV code) saved on your app. You can retrieve these details whenever you need them.
                                </Typography>
                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How to use an Airvend Virtual Card with a Nigerian Paypal account?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            As an alternative, You can add your airvend virtual dollar card to Paypal and use your paypal on the platforms.
                        </Typography>

                        </AccordionDetails>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            To add your card to PayPal (if you're doing this from Nigeria), simply go to the account settings option on PayPal.com. Please note that the billing address must be the same as the address stated below:
                                        </li>
                                    </ul>
                                </Typography>
                                <Typography className="accordion-body">
                                     Address Line 1 : 333 
                                     <br/>Address Line 2 : Fremont Street
                                     <br/>City: San Francisco California
                                     <br/>ZIP CODE - do no input any information
                                     <br/>State: Lagos
                                     <br/>Country: Nigeria
                                </Typography>
    

                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                             Alternatively, if you have a US PayPal account, kindly add the US billing address below;
                                        </li>
                                    </ul>
                                </Typography>
    

                                <Typography className="accordion-body">
                                    Street 1: 333 Fremont Street
                                    <br/>Street 2: San Francisco
                                    <br/>City: San Francisco
                                    <br/>State: CA - California
                                    <br/>Zip Code: 94105
                                    <br/>Once the billing address has been updated, kindly proceed to make use of Paypal on the platforms.
                                </Typography>

                                <Typography className="accordion-body">
                                    Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                                </Typography>



                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>


                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">Want to get the Airvend Mobile App?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            Airvend Mobile App is available on Google Play Store, App Store (iOS) and can also be accessed from our web @ airvend.ng
                        </Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                        <Typography className="accordion-body">
                            Was this answer helpful? Have more questions? You can email us: support@airvend.ng
                        </Typography>
                        </AccordionDetails>

                    </Accordion>

                    <div style={{height: "24px"}}></div>



                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className="acc-heading">How do I fund my Wallet?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{display: 'flex', flexDirection: "column"}}>
                                <Typography className="accordion-body">
                                    You can only fund your Airvend Wallet with your bank’s debit card; this process is powered by Payant Technologies and guarantees the safety and security of your cards.
                                    To  fund your wallet: 
                                </Typography>
                                <Typography className="accordion-body">
                                    <ul>
                                        <li>
                                            Sign Up or Login to the Airvend app 
                                        </li>
                                        <li>
                                            Tap on the add funds icon on the app’s dashboard
                                        </li>
                                        <li>
                                            Enter the Deposit amount you want to fund with... 
                                        </li>
                                    </ul>
                                </Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <div style={{height: "24px"}}></div>

                    <div className="footprint bg-footprint">
                        <div className="footprint-head">
                            Cross platform
                        </div>

                        <div className="footprint-body">
                            We are peculiar about financial inclusion and prioritise the best interest of our customers and we demonstrate this commitment by providing our services through the various channel.
                        </div>

                        <div className="ussd-icon">
                            <div className="ussd">
                                <a href="tel:*174#">
                                    *174#
                                </a>
                            </div>
                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="https://airvend.ng/"}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.05 2.927C13.148 -0.974999 6.83 -0.975999 2.927 2.927C-0.975003 6.83 -0.976003 13.147 2.927 17.05C6.83 20.953 13.147 20.953 17.05 17.05C20.953 13.147 20.953 6.83 17.05 2.927ZM16.633 15.627C16.166 15.209 15.667 14.84 15.141 14.522C15.489 13.321 15.695 11.999 15.743 10.625H18.679C18.547 12.477 17.835 14.215 16.633 15.627ZM1.298 10.625H4.234C4.283 11.999 4.489 13.321 4.836 14.522C4.31 14.84 3.811 15.209 3.345 15.627C2.142 14.214 1.431 12.477 1.298 10.625ZM3.345 4.351C3.811 4.768 4.31 5.137 4.836 5.455C4.489 6.657 4.283 7.978 4.234 9.352H1.298C1.431 7.5 2.142 5.763 3.345 4.351ZM9.352 5.587C8.314 5.513 7.314 5.257 6.386 4.835C6.926 3.445 7.92 1.779 9.352 1.366V5.586V5.587ZM9.352 6.862V9.352H5.507C5.551 8.19 5.716 7.074 5.99 6.052C7.044 6.514 8.178 6.789 9.352 6.862ZM9.352 10.625V13.115C8.178 13.188 7.044 13.464 5.99 13.925C5.716 12.903 5.551 11.787 5.507 10.625H9.352ZM9.352 14.39V18.61C7.92 18.198 6.926 16.532 6.386 15.142C7.314 14.72 8.314 14.465 9.352 14.39ZM10.625 14.39C11.663 14.465 12.664 14.72 13.591 15.142C13.051 16.532 12.057 18.198 10.625 18.611V14.391V14.39ZM10.625 13.115V10.625H14.47C14.426 11.787 14.261 12.903 13.987 13.925C12.933 13.464 11.799 13.188 10.625 13.115ZM10.625 9.352V6.862C11.799 6.789 12.933 6.514 13.987 6.052C14.261 7.074 14.426 8.19 14.47 9.352H10.625ZM10.625 5.587V1.367C12.057 1.779 13.052 3.446 13.591 4.835C12.664 5.257 11.663 5.513 10.625 5.587ZM13.484 2.002C14.298 2.359 15.058 2.842 15.739 3.442C15.415 3.728 15.073 3.988 14.716 4.219C14.398 3.434 13.993 2.67 13.484 2.002ZM5.262 4.219C4.904 3.988 4.562 3.729 4.238 3.442C4.919 2.842 5.679 2.359 6.494 2.002C5.984 2.67 5.579 3.434 5.262 4.219ZM5.262 15.758C5.579 16.543 5.984 17.307 6.494 17.975C5.679 17.619 4.919 17.135 4.238 16.535C4.562 16.249 4.904 15.99 5.262 15.758ZM14.716 15.758C15.073 15.99 15.416 16.248 15.739 16.535C15.059 17.135 14.299 17.619 13.484 17.975C13.993 17.307 14.398 16.543 14.716 15.758ZM15.743 9.352C15.695 7.978 15.489 6.657 15.141 5.455C15.667 5.137 16.166 4.768 16.633 4.351C17.835 5.763 18.547 7.501 18.679 9.352H15.743Z" fill="white"/>
                                </svg>
                            </div>

                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="http://bit.ly/3Airpay"}
                            >
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.44 7.066L15.738 7.514L15.308 7.838C14.695 8.301 13.575 9.145 13.575 10.818C13.575 12.798 14.843 13.56 15.453 13.926C15.722 14.088 16 14.255 16 14.62C16 14.858 14.098 19.97 11.336 19.97C10.66 19.97 10.182 19.767 9.761 19.588C9.335 19.408 8.967 19.251 8.359 19.251C8.051 19.251 7.661 19.397 7.249 19.551C6.685 19.761 6.048 20 5.324 20H5.304C2.402 19.983 0 14.062 0 11.046C0 6.12 3.698 5.042 5.124 5.042C5.766 5.042 6.452 5.294 7.057 5.517C7.48 5.672 7.917 5.833 8.161 5.833C8.307 5.833 8.65 5.696 8.953 5.577C9.599 5.319 10.403 5 11.34 5C12.045 5 14.165 5.153 15.44 7.066ZM10.998 0C11.058 2.421 9.54 4.1 8.024 3.995C7.774 2.063 9.539 0 10.998 0Z" fill="white"/>
                                </svg>
                            </div>

                            <div 
                                className="clickable-icon"
                                onClick={() => window.location.href="https://bit.ly/3Airvend"}
                            >
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.645 11L14 13.445L3 20L11.645 11ZM0.857 0L11 9.998L0.857 20C0.344 19.734 0 19.25 0 18.62V1.38C0 0.75 0.344 0.265 0.857 0ZM15.361 7L17.477 8.321C18.167 8.875 18.167 10.123 17.52 10.677L15.361 12L13 9.5L15.361 7ZM3 0L14 6.555L11.645 9L3 0Z" fill="white"/>
                                </svg>
                            </div>

                        </div>
                    </div>

                    <div style={{height: "90px"}}></div>

                    <div className="footnotes">
                        <div className="foot-tile">
                            <div className="footnote-head">
                                <img src={require("../../components/asset/landing-logo.svg").default} alt="Phone in planet" />
                            </div>

                            <div className="footnote-body">
                                A seamless bill payment service for individuals and businesses.
                            </div>
                        </div>


                        <div className="foot-tile">
                            <div className="footnote-head">
                                Legal
                            </div>

                            <div className="footnote-body">
                                <ul style={{listStyle: "none", margin: 0, padding: 0}}>
                                    <li>
                                        <a href="#">
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Terms of Use
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>


                        <div className="foot-tile">
                            <div className="footnote-head">
                                Resources
                            </div>

                            <div className="footnote-body">
                                <ul style={{listStyle: "none", margin: 0, padding: 0}}>
                                    <li>
                                        <a href="#faqs">
                                            FAQs
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Merchant Guide
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://documenter.getpostman.com/view/6349852/SVSHrpfv">
                                            API Documentation
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>


                        <div className="foot-tile">
                            <div className="footnote-head">
                                Security
                            </div>

                            <div className="footnote-body">
                                <img src={require("../../components/asset/landing-pcidss.svg").default} alt="Phone in planet" />
                            </div>
                        </div>



                    </div>

                    <div style={{height: "60px"}}></div>
                    <div style={{width: "100%", height: "1px", opacity: 0.5, backgroundColor: "#000"}}></div>
                    <div style={{height: "60px"}}></div>

                    <div className="footnotes">
                        <div className="foot-tile">
                            <div className="footnote-head">
                                Abuja
                            </div>

                            <div className="footnote-body">
                                Plot 1132, Cadastral Zone,
                                Katampe District,
                                Abuja, Nigeria.
                            </div>
                        </div>


                        <div className="foot-tile">
                            <div className="footnote-head">
                                Lagos
                            </div>

                            <div className="footnote-body">
                                NO.3 Kunle Adebowale Street,
                                Anthony Village,
                                Lagos, Nigeria.
                            </div>
                        </div>


                        <div className="foot-tile">
                            <div className="footnote-head">
                                Contact
                            </div>
                            <div className="footnote-body">
                                <a href="mailto:support@airvend.ng">
                                    support@airvend.ng
                                </a>
                            </div>

                            <div className="footnote-body" style={{marginTop: 5}}>

                                <div className="app-icons" style={{marginTop: 5}}>
                                    <div 
                                        className="clickable-icon"
                                        onClick={() => console.log("Icon")}
                                        style={{backgroundColor: "white"}}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.8889 0H1.11111C0.816426 0 0.533811 0.117063 0.325437 0.325437C0.117063 0.533811 0 0.816426 0 1.11111V18.8889C0 19.1836 0.117063 19.4662 0.325437 19.6746C0.533811 19.8829 0.816426 20 1.11111 20H10.6833V12.2667H8.08556V9.23889H10.6833V7.01667C10.6833 4.43333 12.2611 3.02556 14.5722 3.02556C15.3489 3.02333 16.1267 3.06333 16.9 3.14444V5.83333H15.3056C14.0522 5.83333 13.8078 6.43111 13.8078 7.30556V9.23333H16.8044L16.4156 12.2611H13.8067V20H18.8889C19.1836 20 19.4662 19.8829 19.6746 19.6746C19.8829 19.4662 20 19.1836 20 18.8889V1.11111C20 0.816426 19.8829 0.533811 19.6746 0.325437C19.4662 0.117063 19.1836 0 18.8889 0Z" fill="black"/>
                                        </svg>
                                    </div>

                                    <div 
                                        className="clickable-icon"
                                        onClick={() => window.location.href = "https://twitter.com/airvendng"}
                                        style={{backgroundColor: "white"}}
                                    >
                                        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M23.9528 2.56963C23.0545 2.96451 22.1031 3.22529 21.129 3.34363C22.1558 2.72735 22.9245 1.75988 23.2928 0.620375C22.3216 1.18363 21.2645 1.58369 20.1638 1.80463C19.4235 1.01372 18.443 0.489219 17.3742 0.312499C16.3055 0.13578 15.2083 0.316721 14.2529 0.827251C13.2974 1.33778 12.5372 2.14936 12.0901 3.13606C11.6431 4.12277 11.5341 5.22944 11.7803 6.28438C7.6905 6.09313 4.065 4.12813 1.64025 1.15963C1.19886 1.91029 0.968011 2.76607 0.972005 3.63688C0.971403 4.4464 1.17071 5.24354 1.55223 5.95752C1.93376 6.6715 2.48568 7.28022 3.159 7.72963C2.37872 7.70604 1.61544 7.49593 0.933004 7.11688V7.17613C0.932766 8.31239 1.32541 9.41379 2.04439 10.2937C2.76338 11.1735 3.76447 11.7777 4.878 12.0039C4.4562 12.1166 4.0216 12.1743 3.585 12.1756C3.26925 12.1756 2.96775 12.1449 2.667 12.0894C2.9839 13.0672 3.59776 13.9218 4.42314 14.5344C5.24851 15.147 6.24434 15.487 7.272 15.5071C5.53081 16.8707 3.38234 17.6105 1.17075 17.6079C0.779034 17.6094 0.387576 17.5874 -0.00149536 17.5419C2.25457 18.9875 4.87828 19.7549 7.55775 19.7529C16.608 19.7529 21.5535 12.2566 21.5535 5.76463C21.5535 5.55763 21.5535 5.34688 21.5378 5.13538C22.5052 4.44204 23.3389 3.57909 23.9985 2.58838L23.9528 2.56963Z" fill="black"/>
                                        </svg>
                                    </div>

                                    <div 
                                        className="clickable-icon"
                                        onClick={() => window.location.href="https://instagram.com/airvend.ng?utm_medium=copy_link"}
                                        style={{backgroundColor: "white"}}
                                    >
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.465 0.066C7.638 0.012 8.012 0 11 0C13.988 0 14.362 0.013 15.534 0.066C16.706 0.119 17.506 0.306 18.206 0.577C18.939 0.854 19.604 1.287 20.154 1.847C20.714 2.396 21.146 3.06 21.422 3.794C21.694 4.494 21.88 5.294 21.934 6.464C21.988 7.639 22 8.013 22 11C22 13.988 21.987 14.362 21.934 15.535C21.881 16.705 21.694 17.505 21.422 18.205C21.146 18.9391 20.7133 19.6042 20.154 20.154C19.604 20.714 18.939 21.146 18.206 21.422C17.506 21.694 16.706 21.88 15.536 21.934C14.362 21.988 13.988 22 11 22C8.012 22 7.638 21.987 6.465 21.934C5.295 21.881 4.495 21.694 3.795 21.422C3.06092 21.146 2.39582 20.7133 1.846 20.154C1.28638 19.6047 0.853315 18.9399 0.577 18.206C0.306 17.506 0.12 16.706 0.066 15.536C0.012 14.361 0 13.987 0 11C0 8.012 0.013 7.638 0.066 6.466C0.119 5.294 0.306 4.494 0.577 3.794C0.853723 3.06008 1.28712 2.39531 1.847 1.846C2.39604 1.2865 3.06047 0.853443 3.794 0.577C4.494 0.306 5.294 0.12 6.464 0.066H6.465ZM15.445 2.046C14.285 1.993 13.937 1.982 11 1.982C8.063 1.982 7.715 1.993 6.555 2.046C5.482 2.095 4.9 2.274 4.512 2.425C3.999 2.625 3.632 2.862 3.247 3.247C2.88205 3.60205 2.60118 4.03428 2.425 4.512C2.274 4.9 2.095 5.482 2.046 6.555C1.993 7.715 1.982 8.063 1.982 11C1.982 13.937 1.993 14.285 2.046 15.445C2.095 16.518 2.274 17.1 2.425 17.488C2.601 17.965 2.882 18.398 3.247 18.753C3.602 19.118 4.035 19.399 4.512 19.575C4.9 19.726 5.482 19.905 6.555 19.954C7.715 20.007 8.062 20.018 11 20.018C13.938 20.018 14.285 20.007 15.445 19.954C16.518 19.905 17.1 19.726 17.488 19.575C18.001 19.375 18.368 19.138 18.753 18.753C19.118 18.398 19.399 17.965 19.575 17.488C19.726 17.1 19.905 16.518 19.954 15.445C20.007 14.285 20.018 13.937 20.018 11C20.018 8.063 20.007 7.715 19.954 6.555C19.905 5.482 19.726 4.9 19.575 4.512C19.375 3.999 19.138 3.632 18.753 3.247C18.3979 2.88207 17.9657 2.60121 17.488 2.425C17.1 2.274 16.518 2.095 15.445 2.046ZM9.595 14.391C10.3797 14.7176 11.2534 14.7617 12.0669 14.5157C12.8805 14.2697 13.5834 13.7489 14.0556 13.0422C14.5278 12.3356 14.7401 11.4869 14.656 10.6411C14.572 9.79534 14.197 9.00497 13.595 8.405C13.2112 8.02148 12.7472 7.72781 12.2363 7.54515C11.7255 7.36248 11.1804 7.29536 10.6405 7.34862C10.1006 7.40187 9.57915 7.57418 9.1138 7.85313C8.64845 8.13208 8.25074 8.51074 7.9493 8.96185C7.64786 9.41296 7.45019 9.92529 7.37052 10.462C7.29084 10.9986 7.33115 11.5463 7.48854 12.0655C7.64593 12.5847 7.91648 13.0626 8.28072 13.4647C8.64496 13.8668 9.09382 14.1832 9.595 14.391ZM7.002 7.002C7.52702 6.47697 8.15032 6.0605 8.8363 5.77636C9.52228 5.49222 10.2575 5.34597 11 5.34597C11.7425 5.34597 12.4777 5.49222 13.1637 5.77636C13.8497 6.0605 14.473 6.47697 14.998 7.002C15.523 7.52702 15.9395 8.15032 16.2236 8.8363C16.5078 9.52228 16.654 10.2575 16.654 11C16.654 11.7425 16.5078 12.4777 16.2236 13.1637C15.9395 13.8497 15.523 14.473 14.998 14.998C13.9377 16.0583 12.4995 16.654 11 16.654C9.50046 16.654 8.06234 16.0583 7.002 14.998C5.94166 13.9377 5.34597 12.4995 5.34597 11C5.34597 9.50046 5.94166 8.06234 7.002 7.002ZM17.908 6.188C18.0381 6.06527 18.1423 5.91768 18.2143 5.75397C18.2863 5.59027 18.3248 5.41377 18.3274 5.23493C18.33 5.05609 18.2967 4.87855 18.2295 4.71281C18.1622 4.54707 18.0624 4.39651 17.936 4.27004C17.8095 4.14357 17.6589 4.04376 17.4932 3.97652C17.3275 3.90928 17.1499 3.87598 16.9711 3.87858C16.7922 3.88119 16.6157 3.91965 16.452 3.9917C16.2883 4.06374 16.1407 4.1679 16.018 4.298C15.7793 4.55103 15.6486 4.88712 15.6537 5.23493C15.6588 5.58274 15.7992 5.91488 16.0452 6.16084C16.2911 6.40681 16.6233 6.54723 16.9711 6.5523C17.3189 6.55737 17.655 6.42669 17.908 6.188Z" fill="black"/>
                                        </svg>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>


                </div>


            </div>


            <footer style={{height: "40px"}}>
                © Callphone Limited, 2020.
            </footer>

        </>
    )
}

export default LandingPage
